import { H2, Page, Card } from '../components';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import learndleTile from '../assets/images/learndle-game-tile.jpg';

function ChildDashboardPage() {
  const navigate = useNavigate();

  const handleGamePlay = (route) => {
    navigate(route);
  };

  const goToLearndle = () => handleGamePlay('/games/learndle-word');

  return (
    <Page maxWidth="md" fullHeight>
      <Box sx={{ py: 4, display: 'flex', justifyContent: 'center' }}>
        <Card
          elevation={3}
          sx={{
            width: '100%',
            maxWidth: 680,
            cursor: 'pointer',
            overflow: 'hidden',
            borderRadius: 3,
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            '&:hover': { boxShadow: 6, transform: 'translateY(-2px)' },
          }}
          onClick={goToLearndle}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              goToLearndle();
            }
          }}
        >
          <Box sx={{ position: 'relative', height: 320 }}>
            <Box
              component="img"
              src={learndleTile}
              alt="Learndle Word"
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block',
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                left: 0,
                right: 0,
                bottom: 0,
                p: 2,
                background:
                  'linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.9) 100%)',
              }}
            >
              <H2
                sx={{
                  mb: 0,
                  color: 'common.white',
                  fontSize: '2rem',
                  fontWeight: 'bold',
                }}
              >
                Learndle Word
              </H2>
            </Box>
          </Box>
        </Card>
      </Box>
    </Page>
  );
}

export default ChildDashboardPage;
